import { MULTIPLAYER_USER_COLORS } from "../utils/constants"

type MultiplayerUserIndicatorProps = {
  firstName?: string
  lastName?: string
  userPicture?: string
  userIndex: number
}

export const MultiplayerUserIndicator = ({
  firstName,
  lastName,
  userPicture,
  userIndex,
}: MultiplayerUserIndicatorProps) => {
  const colorIndex = userIndex % MULTIPLAYER_USER_COLORS.length

  return firstName || lastName || userPicture ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "14px",
        flexDirection: "column",
        marginRight: "8px",
        border: `3px solid ${MULTIPLAYER_USER_COLORS[colorIndex]}`,
        borderRadius: "50%",
      }}
      title={`${firstName} ${lastName}`}
    >
      {userPicture ? (
        <img
          src={userPicture}
          alt={`${firstName} ${lastName}`}
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            backgroundColor: MULTIPLAYER_USER_COLORS[colorIndex],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 12,
          }}
        >
          {firstName?.charAt(0).toUpperCase()}
          {lastName?.charAt(0).toUpperCase()}
        </div>
      )}
    </div>
  ) : null
}
